











































































































































































































































































































































































































































































import { Component, Vue, Prop, InjectReactive, Watch, PropSync } from 'vue-property-decorator';
import {
  PaycheckForm, PaycheckFormLine,
  lineIsTaxDeductionOrdinary,
  moveExcessTaxDeductiontoTaxDeductionVolunary,
  findTaxDeductionLine,
} from './PaycheckForm';
import { GQL_PaycheckLineUpdate, GQL_AltinnFordelEnum, GQL_PaycheckLineCalculationTypeEnum } from '@/queries/global';
import { SmartQuery } from 'vue-apollo-decorator';
import { ALL_CARS } from '@/queries/Car';
import { ALL_DEPARTMENTS } from '@/queries/Department';
import { ALL_PROJECTS } from '@/queries/Project';
import { GQL_currentUnitCars, GQL_currentUnitCars_currentUnit_cars } from '@/queries/__generated__/currentUnitCars';
import { GQL_currentUnitProjects, GQL_currentUnitProjects_currentUnit_projects } from '@/queries/__generated__/currentUnitProjects';
import { GQL_currentUnitDepartments, GQL_currentUnitDepartments_currentUnit_departments } from '@/queries/__generated__/currentUnitDepartments';
import indexOf from 'lodash/indexOf';
import { generateUID, WithUID, sortBy } from '@/utils/utils';
import { GQL_workRelationPaycheckSums_workRelation_paycheckSums } from '@/queries/__generated__/workRelationPaycheckSums';
import cloneDeep from 'lodash/cloneDeep';
import uniq from 'lodash/uniq';
import { MAXIMUM_LINE_QUANTITY, MAXIMUM_LINE_RATE, sumCorrectPaycheckLines } from '@/app/Paycheck';
import Decimal from '@/utils/decimal';
import { WatchObjectAsJson } from '@/decorators/watch-object-as-json';
import { taxCalculator, TaxDeductionCalculation, TaxDeductionCalculationResult } from '@/app/Skatteetaten/tax-deduction';
import formatAmount from '@/filters/formatAmount';

interface IUneditablePaycheckLine {
  id: null;
  __typename: 'PaycheckLine';
  _fake: true;
  number: number;
  description: string;
  altinnFordel: GQL_AltinnFordelEnum | null;
  calculationType: GQL_PaycheckLineCalculationTypeEnum;
  altinnDescription: null;
  altinnAdditional: null;
  quantity: Decimal;
  rate: Decimal;
  sum: Decimal;
  taxable: false;
  taxDeduction: false;
  taxDeductionVoluntary: false;
  vacationMoneyEarnedInPreviousYear: boolean;
}

interface INotFake {
  _fake: undefined;
}
type FakePaycheckLine = IUneditablePaycheckLine;
type PaycheckLine = PaycheckFormLine & INotFake | FakePaycheckLine;

@Component({
  i18n: {
    messages: {
      en: {
        altinnAdditional: {
          carAndBoat: {
            carRegistrationNumber: "Registration number to Car",
            listPriceForCar: "List price as new",
          },
        },
      },
      nb: {
        altinnAdditional: {
          carAndBoat: {
            carRegistrationNumber: "Bilens registreringnr",
            listPriceForCar: "Listepris for bilen",
          },
        },
      },
    },
  },
})
export default class PaycheckLinesTable extends Vue {
  @SmartQuery<PaycheckLinesTable, GQL_currentUnitCars>({
    query: () => ALL_CARS,
    update: data => data.currentUnit.cars,
    skip() { return this.isLocked || !this.hasEditPermissions },
  }) private cars!: GQL_currentUnitCars_currentUnit_cars[];

  @SmartQuery<PaycheckLinesTable, GQL_currentUnitProjects>({
    query: ALL_PROJECTS,
    update: data => data.currentUnit.projects,
    skip() { return this.isLocked || !this.hasEditPermissions },
  }) private projects!: GQL_currentUnitProjects_currentUnit_projects[];

  @SmartQuery<PaycheckLinesTable, GQL_currentUnitDepartments>({
    query: ALL_DEPARTMENTS,
    update: data => data.currentUnit.departments,
    skip() { return this.isLocked || !this.hasEditPermissions },
  }) private departments!: GQL_currentUnitDepartments_currentUnit_departments[];

  @Prop({ type: Object, required: true }) private paycheck!: PaycheckForm;
  @InjectReactive() private isLocked!: boolean;
  @InjectReactive() private isPrint!: boolean;
  @InjectReactive() private hasEditPermissions!: boolean;
  @Prop({ type: Array, required: true }) private paycheckSums!: GQL_workRelationPaycheckSums_workRelation_paycheckSums[];

  @PropSync('sum', { type: Object, default: () => new Decimal(0) }) private sumSync!: Decimal;

  private mounted() {
    if (!this.paycheck.id) {
      this.notDeletedLines.forEach(line => {
        this.checkForUnusualAmounts(line);
      });
    }
  }

  private moveExcessTaxDeductiontoTaxDeductionVolunaryInProgress = false;
  private formatAmount = formatAmount;

  private get showTaxExemptionAmountLimitWarning() {
    return !!(this.paycheck.taxDeductionMethod === "TAX_EXEMPTION" && (!this.paycheck.taxExemptionAmountLimit || this.paycheck.taxExemptionAmountLimit!.equals(0)));
  }

  private get notDeletedLines(): WithUID<PaycheckLine>[] {
    return (this.paycheck.paycheckLines as WithUID<PaycheckLine>[]).filter((line: GQL_PaycheckLineUpdate) => !line._destroy);
  }

  private get printedLines(): WithUID<PaycheckLine>[] {
    const unsorted = this.notDeletedLines
      .concat(this.paycheckSumLines);

    return sortBy(unsorted, (item) => [ [ item.number, 'asc' ], [ parseInt(item.id || '0'), 'asc' ] ]);
  }

  private get showUnusualAmounts(): boolean {
    return !!this.unconfirmedLinesWithUnusualAmount.length;
  }

  private unconfirmedLinesWithUnusualAmount: PaycheckLine[] = [];

  private checkForUnusualAmounts(line: PaycheckLine) {
    if (this.lineHasUnusualAmount(line)) {
      this.unconfirmedLinesWithUnusualAmount.push(line);
    }
  }

  private lineHasUnusualAmount(line: PaycheckLine): boolean {
    return (
      line.rate.greaterThan(MAXIMUM_LINE_RATE) ||
      line.quantity.greaterThan(MAXIMUM_LINE_QUANTITY)
    );
  }

  private confirmUnusualAmounts() {
    this.unconfirmedLinesWithUnusualAmount = [];
  }

  private clearUnusualAmounts() {
    this.unconfirmedLinesWithUnusualAmount.forEach(line => {
      if (line.rate.greaterThan(MAXIMUM_LINE_RATE)) {
        line.rate = new Decimal(0);
      }
      if (line.quantity.greaterThan(MAXIMUM_LINE_QUANTITY)) {
        line.quantity = new Decimal(0);
      }
      line.sum = new Decimal(0);
    });

    this.unconfirmedLinesWithUnusualAmount = [];
  }

  private get paycheckSumLines(): WithUID<FakePaycheckLine>[] {
    const realLineNumbers = this.notDeletedLines
      .map(line => line.number);

    const sums = this.paycheckSums
      .filter(sum => !realLineNumbers.includes(sum.number))
      .filter(sum => !sum.sum.isZero());

    return sums.map((sum) => {
      return {
        id: null,
        __typename: 'PaycheckLine',
        $_UID: generateUID(),
        number: sum.number,
        description: sum.description,
        altinnFordel: sum.altinnFordel,
        altinnDescription: null,
        altinnAdditional: null,
        calculationType: sum.calculationType,
        _fake: true,
        quantity: new Decimal(0),
        rate: new Decimal(0),
        sum: new Decimal(0),
        taxable: false,
        taxDeduction: false,
        taxDeductionVoluntary: false,
        vacationMoneyEarnedInPreviousYear: false,
      };
    });
  }

  private duplicateLine(line: WithUID<PaycheckLine>): void {
    this.paycheck.paycheckLines.splice(
      indexOf(this.paycheck.paycheckLines as WithUID<PaycheckLine>[], line) + 1,
      0,
      {
        ...cloneDeep(line),
        id: null,
        quantity: new Decimal(0),
        rate: new Decimal(0),
        sum: new Decimal(0),
        $_UID: generateUID(),
      } as WithUID<PaycheckLine>,
    );
  }


  private removeLine(line: WithUID<PaycheckLine>): void {
    if (this.notDeletedLines.filter(l => l.number === line.number).length === 1) {
      this.duplicateLine(line);
      this.$sMessage.info(this.$t('Paycheck.PaycheckLines.newLineAddedAfterRemovingLast'));
    }

    if (line.id) {
      this.$set(line, '_destroy', true);
    } else {
      this.paycheck.paycheckLines.splice(
        indexOf(this.paycheck.paycheckLines as WithUID<PaycheckLine>[], line),
        1,
      );
    }
  }

  @Watch('paycheck.paycheckLines', { immediate: true })
  private ensureUIDsAreSet(): void {
    (this.paycheck.paycheckLines as WithUID<PaycheckLine>[]).forEach(line => {
      if (!line.$_UID) {
        line.$_UID = generateUID();
      }
    });
  }

  private displayTaxDeductionWarning = false;
  private taxDeductionWarning: TaxDeductionCalculation | null = null;
  private taxDeductionWarningExcessTaxDeductionOrdinary: Decimal | null = null;

  private displayCantCalculateTaxDeductionForNegativeWarning = false;

  @Watch('paycheck.taxDeductionMethod')
  @Watch('paycheck.paycheckLines', { deep: true, immediate: true })
  private async checkValidTaxExemption() {
    const taxCalculations = await this.calculateTaxDeduction();
    if (taxCalculations.kind === `calculation`) {
      const ordinaryTaxDeduction: Decimal = this.notDeletedLines
        .filter(lineIsTaxDeductionOrdinary)
        .reduce(((acc, line) => acc.plus(line.sum)), new Decimal(0));
      const taxCardTaxDeduction: Decimal = taxCalculations.taxDeduction.times(-1);

      this.displayTaxDeductionWarning =
        !taxCardTaxDeduction!.equals(ordinaryTaxDeduction) ||
        !!taxCalculations.error;

      if (ordinaryTaxDeduction.lessThan(taxCardTaxDeduction)) {
        this.taxDeductionWarningExcessTaxDeductionOrdinary = ordinaryTaxDeduction.minus(taxCardTaxDeduction);
      } else {
        this.taxDeductionWarningExcessTaxDeductionOrdinary = null;
      }

      this.taxDeductionWarning = taxCalculations;
    } else {
      this.displayTaxDeductionWarning = false;
      this.taxDeductionWarningExcessTaxDeductionOrdinary = null;
      this.taxDeductionWarning = null;
    }

    this.displayCantCalculateTaxDeductionForNegativeWarning =
      taxCalculations.kind === `cant_calculate_for_negative`;
  }

  private isFirstLineOfItsNumber(line: WithUID<PaycheckLine>): boolean {
    return this.printedLines.filter(l => l.number === line.number)[0] === line;
  }

  private sumThisYear(lineNumber: number): Decimal {
    const paycheckSum = this.paycheckSums.find(sum => sum.number === lineNumber);
    return (paycheckSum ? paycheckSum.sum : new Decimal(0)).add(
      (this.printedLines as WithUID<PaycheckLine>[])
        .filter(line => line.number === lineNumber)
        .reduce((sum, line) => sum.add(line.sum), new Decimal(0)),
    );
  }

  private get totalSumThisYear(): Decimal {
    return uniq(
      this.printedLines
        .filter(line => line.calculationType === GQL_PaycheckLineCalculationTypeEnum.CASHEDOUT)
        .map(l => l.number),
    )
      .reduce((sum, number) => sum.add(this.sumThisYear(number)), new Decimal(0));
  }

  @WatchObjectAsJson('notDeletedLines', { immediate: true })
  private setSumSync(): void {
    this.sumSync = sumCorrectPaycheckLines(this.notDeletedLines);
  }

  private calculateSum(line: WithUID<PaycheckLine>): void {
    if (!line.quantity.isZero() && !line.rate.isZero() && line.sum.isZero()) {
      line.sum = line.quantity.times(line.rate);
    }
  }

  private removeDecimal(line: WithUID<PaycheckLine>, attribute: 'quantity' | 'rate' | 'sum'): void {
    if (!line.taxDeduction) return;
    line[attribute] = line[attribute].toDecimalPlaces(0, Decimal.ROUND_DOWN);
  }

  private roundDownToClosestHundred(amount: Decimal): Decimal {
    return amount.minus(amount.modulo(100));
  }

  public async calculateTaxDeduction(): Promise<TaxDeductionCalculationResult> {
    const calculator = taxCalculator(this.paycheck, this.paycheckSums);
    if(!this.paycheck.taxDeductionMethod) {
      return calculator.emptyTaxDeductionCalculation();
    }

    return calculator.calculateTaxDeduction(this.paycheck.taxDeductionMethod);
  }

  private setTaxDeductionAmounts() {
    if (!this.taxDeductionWarning) return;

    const taxDeductionLine = findTaxDeductionLine(this.paycheck);
    if (!taxDeductionLine) return;

    this.notDeletedLines
      .filter(lineIsTaxDeductionOrdinary)
      .forEach(line => {
        line.quantity = new Decimal(0);
        line.rate = new Decimal(0);
        line.sum = new Decimal(0);
      });

    taxDeductionLine.sum = this.taxDeductionWarning.taxDeduction.times(-1);
  }

  private clickMoveExcessTaxDeductiontoTaxDeductionVolunary() {
    const taxDeductionToMove = this.taxDeductionWarningExcessTaxDeductionOrdinary;
    if (!taxDeductionToMove) return;

    this.moveExcessTaxDeductiontoTaxDeductionVolunaryInProgress = true;
    moveExcessTaxDeductiontoTaxDeductionVolunary(this.paycheck, taxDeductionToMove)
      .finally(() => { this.moveExcessTaxDeductiontoTaxDeductionVolunaryInProgress = false });
  }

  private selectCar(item: PaycheckLine, car: GQL_currentUnitCars_currentUnit_cars) {
    if (item.altinnDescription === `bil`) {
      item.altinnAdditional.carAndBoat.listPriceForCar = car.norwegianListPriceAsNew;
      item.altinnAdditional.carAndBoat.carRegistrationNumber = car.registrationNumber;
    }
  }
}
